/** React bindings for the card's module-level state (B8). */
import { useEffect, useSyncExternalStore } from "react";
import { getDriveHold, subscribeDriveHold } from "./driveState";
import { acquireSequence, getSequence, subscribeSequence, type SeqSnapshot } from "./sequence";

/** The select sequence (acquires the shared controller while mounted). */
export function useSequence(): SeqSnapshot {
  useEffect(() => acquireSequence(), []);
  return useSyncExternalStore(subscribeSequence, getSequence, getSequence);
}

/** true while the drive HUD holds its arrival caption. */
export function useDriveHold(): boolean {
  return useSyncExternalStore(subscribeDriveHold, getDriveHold, getDriveHold);
}
